import { getWithRetry } from './base';
import { getCurrentLanguage } from '../i18n';

export const getProductDocuments = async (productName: string) =>
  await getWithRetry({
    url: `/product-documents/${productName}`,
    config: {
      query: { lang: getCurrentLanguage() },
    },
  });
